import * as PlanDetailsUI from '../PlanDetailsUI';
import { SvgIcon } from '../../../../components/Icon';
import React from 'react';

const PlanActions = () => (
  <PlanDetailsUI.Actions>
    <PlanDetailsUI.ContactButton
      type="button"
      onClick={() => (window.location.href = 'mailto:sales@kibit.co')}
    >
      Contact sales{' '}
      <SvgIcon
        name="arrow-right"
        customFill="currentColor"
        width={16}
        height={16}
      />
    </PlanDetailsUI.ContactButton>
    <div>Manage plan with our customer success team.</div>
  </PlanDetailsUI.Actions>
);

export default PlanActions;
